// apiConfig
import axios from "axios"
import { store } from './store/state-loader.js'
import { basicURL } from './apiConfig.js'

axios.defaults.baseURL = basicURL + 'api'; // Remoción de pretty URL, en favor de la configuración del servidor de Laravel.
axios.defaults.maediaImageRender = basicURL + 'img/render/'; // Remoción de pretty URL, en favor de la configuración del servidor de Laravel.
axios.defaults.timeout = 60000
axios.defaults.withCredentials = false
axios.interceptors.request.use((config) => {

    // Do something before request is sent
    config.headers['Content-Type'] = 'application/json';

    if (!!store.getters.accountGetToken)
        config.headers['AUTH-TOKEN'] = store.getters.accountGetToken;
    else if (typeof config.headers['AUTH-TOKEN'] != 'undefined')
        delete config.headers['AUTH-TOKEN'];

    if (!!axios.defaults.headers.common && !!axios.defaults.headers.common['X-Requested-With'])
        delete axios.defaults.headers.common['X-Requested-With'];

    return config;

}, (error) => {
    // Do something with request error
    return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use((response) => {
    // Do something with response data
    let returnable = response.data
    return returnable
}, (error) => {
    // Do something with response error
    return Promise.reject(error);
});